import React, { useState, useEffect, useCallback } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { ConfirmDialog } from "@/components/ConfirmDialog";
import { Loading, Empty, SectionHeader, Card } from "./shared";

export default function AdminGsa() {
  const [orgs, setOrgs] = useState(null);
  const [confirm, setConfirm] = useState(null); // {org, enabled}
  const [saving, setSaving] = useState(false);

  const load = useCallback(() => { api.get("/admin/organizations").then((r) => setOrgs(r.data.organizations || [])).catch(() => setOrgs([])); }, []);
  useEffect(() => { load(); }, [load]);
  if (orgs === null) return <Loading />;

  const apply = async () => {
    setSaving(true);
    try {
      await api.patch(`/admin/organizations/${confirm.org.id}/gsa`, { enabled: confirm.enabled });
      toast.success(`GSA ${confirm.enabled ? "activé" : "désactivé"} · ${confirm.org.name}`);
      setConfirm(null);
      load();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail, err.message)); }
    finally { setSaving(false); }
  };

  return (
    <div data-testid="admin-gsa">
      <SectionHeader title="GSA Activation" subtitle="Module optionnel de représentation commerciale internationale. Non requis pour la plateforme principale." />
      {orgs.length === 0 ? <Empty label="Aucune organisation." testid="gsa-empty" /> : (
        <Card>
          {orgs.map((o) => (
            <div key={o.id} data-testid={`gsa-org-${o.id}`} className="flex items-center justify-between border-b border-slate-100 px-5 py-3 last:border-0">
              <div><p className="text-sm font-semibold text-[#17201A]">{o.name}</p><p className="text-xs text-slate-400">{o.type}</p></div>
              <div className="flex items-center gap-2">
                <span className="text-xs font-semibold text-slate-500">{o.gsa_enabled ? "Activé" : "Désactivé"}</span>
                <Switch data-testid={`gsa-toggle-${o.id}`} checked={!!o.gsa_enabled} onCheckedChange={(v) => setConfirm({ org: o, enabled: v })} />
              </div>
            </div>
          ))}
        </Card>
      )}
      <ConfirmDialog
        open={!!confirm} onOpenChange={(o) => !o && setConfirm(null)}
        title={confirm?.enabled ? "Activer GSA Worldwide" : "Désactiver GSA Worldwide"}
        description={confirm ? `Confirmer ${confirm.enabled ? "l'activation" : "la désactivation"} du module GSA pour « ${confirm.org.name} » ? ${confirm.enabled ? "" : "Les données GSA existantes seront conservées mais inaccessibles."} Cette action est journalisée.` : ""}
        confirmLabel={confirm?.enabled ? "Activer" : "Désactiver"} destructive={confirm && !confirm.enabled}
        loading={saving} onConfirm={apply}
      />
    </div>
  );
}
